module.exports = __webpack_public_path__ + "static/media/icon-team.54661439.svg";